<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense nav>
        <div
          v-for="navigationItem in filteredNavigationItems"
          :key="navigationItem.title"
          class="mb-3"
        >
          <v-list-item
            link
            :to="navigationItem.route"
            active-class="primary--text"
            v-if="!navigationItem.childrens"
          >
            <v-list-item-icon>
              <v-icon>{{ navigationItem.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ navigationItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-else
            :value="
              navigationItem.catchRoutes.includes($router.currentRoute.path)
            "
          >
            <!-- v-model="navigationItem.active"  -->
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>
                  {{ navigationItem.icon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  navigationItem.title
                }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(subitem, index) in navigationItem.childrens"
              :key="index"
              class="ml-5"
              :to="subitem.route"
            >
              <v-list-item-icon>
                <v-icon>{{ subitem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ subitem.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left elevation="3" dense class="primary">
      <v-app-bar-nav-icon @click="drawer = !drawer" style="color: white">
      </v-app-bar-nav-icon>
      <v-toolbar-title class="pl-2">
        <!-- <v-img
          :src="API_BASE_URL + '/web_front/icon_logo.svg'"
          max-height="40px"
          max-width="100px"
          contain
        ></v-img> -->
        <div style="color: white">{{ user.name }}</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu transition="slide-y-transition" bottom offset-y right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn large icon v-bind="attrs" v-on="on">
            <v-avatar
              size="35"
              v-if="user.logo_url != null"
              class="cursor-pointer"
            >
              <img
                :src="API_BASE_URL + '/uploads/' + user.logo_url"
                :alt="user.name"
              />
            </v-avatar>
            <v-avatar
              v-if="user.logo_url == null"
              color="secondary"
              class="white--text cursor-pointer"
              size="35"
            >
              <span class="font-30">{{
                user.name ? user.name.charAt(0) : ""
              }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense nav color="primary--text" class="min-width-200">
          <v-list-item
            v-for="(menuItem, i) in menuItems"
            :key="i"
            :to="menuItem.route"
          >
            <v-list-item-icon>
              <v-icon right>{{ menuItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="dialogFeedback = true">
            <v-list-item-icon>
              <v-icon right>mdi-comment-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Feedback</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon right>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-dialog v-model="dialogFeedback" max-width="500" persistent>
      <VForm ref="form">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Feedback / Suggestion
          </v-card-title>
          <v-card-text>
            <div class="mt-4">
              <v-text-field
                outlined
                required
                density="compact"
                placeholder="Enter Title"
                label="Enter Title"
                v-model="feedback.title"
                maxlength="32"
                v-validate="'required'"
                :error="
                  errors.first('title') != null ||
                  serverSideErrors.title != null
                "
                :error-messages="
                  errors.first('title') || serverSideErrors.title
                "
              />

              <v-textarea
                outlined
                required
                density="compact"
                placeholder="Enter description"
                label="Enter description"
                v-model="feedback.description"
                v-validate="'required'"
                :error="
                  errors.first('description') != null ||
                  serverSideErrors.description != null
                "
                :error-messages="
                  errors.first('description') || serverSideErrors.description
                "
              />

              <v-file-input
                outlined
                placeholder="Select File"
                accept="image/jpeg, image/jpg ,image/png"
                v-model="feedback.picture"
                density="compact"
              ></v-file-input>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-btn color="primary" text @click="submitForm">Send</v-btn>
            <v-btn color="primary" text @click="closeView">cancel</v-btn>
          </v-card-actions>
        </v-card>
      </VForm>
    </v-dialog>

    <Alert />

    <v-main class="blue-grey lighten-5">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Alert from "../../Alert.vue";
import { mapMutations } from "vuex";

export default {
  name: "App",

  components: {
    Alert,
  },

  data: () => ({
    feedback: { title: "", description: "", picture: null },
    drawer: true,
    dialogFeedback: false,
    serverSideErrors: {},

    navigationItems: [
      {
        title: "Dashboard",
        icon: "mdi-view-dashboard",
        route: "/societyadmin/dashboard",
      },
      {
        title: "Block Management",
        icon: "mdi-home-modern",
        route: "/societyadmin/block",
      },
      // { title: 'Members',icon: 'mdi-home', route: '/societyadmin/house' },
      {
        title: "Members",
        icon: "mdi-home",
        active: false,
        catchRoutes: [
          "/societyadmin/house/requests",
          "/societyadmin/house/list",
        ],
        childrens: [
          {
            title: "Requests",
            icon: "mdi-share-outline",
            route: "/societyadmin/house/requests",
          },
          {
            title: "List",
            icon: "mdi-format-list-bulleted",
            route: "/societyadmin/house/list",
          },
        ],
      },
      {
        title: "Announcement",
        icon: "mdi-bullhorn", // Update the icon here
        route: "/societyadmin/announcement",
      },
      {
        title: "Events",
        icon: "mdi-calendar-clock",
        route: "/societyadmin/event",
      },
      {
        title: "Notice",
        icon: " mdi-clipboard",
        route: "/societyadmin/notice",
      },
      {
        title: "Committee Members",
        icon: "mdi-account-multiple-outline",
        route: "/societyadmin/committemember",
      },
      {
        title: "Staff",
        icon: "mdi-account-switch",
        route: "/societyadmin/staff",
      },
      {
        title: "Security Guard",
        icon: "mdi-security ",
        route: "/societyadmin/securityguard",
      },
      {
        title: "Visitor",
        icon: "mdi-account-switch",
        route: "/societyadmin/visitor",
      },
      {
        title: "Request Approval Member",
        icon: "mdi-account-star",
        route: "/societyadmin/responsibleperson",
      },
      {
        title: "Help Desk",
        icon: "mdi-help",
        route: "/societyadmin/complaints",
      },
      {
        title: "Expense",
        icon: "mdi-cash-100",
        active: false,
        catchRoutes: ["/societyadmin/expense", "/societyadmin/category"],
        childrens: [
          {
            title: "List",
            icon: "mdi-format-list-bulleted",
            route: "/societyadmin/expense",
          },
          {
            title: "Category",
            icon: "mdi-view-grid-outline",
            route: "/societyadmin/category",
          },
        ],
      },
      {
        title: "Bill Master",
        icon: "mdi-currency-inr",
        route: "/societyadmin/bills",
      },
      {
        title: "Bills",
        icon: "mdi-cash-100",
        route: "/societyadmin/bills/house",
      },
      {
        title: "Gallery",
        icon: "mdi-panorama",
        route: "/societyadmin/gallery",
      },
      {
        title: "Permissions",
        icon: "mdi-shield-check",
        route: "/societyadmin/permissions",
      },
      {
        title: "My Plan",
        icon: "mdi-diamond-outline",
        route: "/societyadmin/plan",
      },
    ],
    menuItems: [
      {
        title: "Profile",
        icon: "mdi-account-outline",
        route: "/societyadmin/profile",
      },
      {
        title: "Theme",
        icon: "mdi-theme-light-dark",
        route: "/societyadmin/theme",
      },
    ],
    user: {
      name: "",
      email: "",
    },
    isExpired: [],
  }),
  created() {
    this.getSocietyDetail();
    this.getUserPlan();
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    closeView() {
      this.dialogFeedback = false;
      this.feedback = { title: "", description: "", picture: null };
    },
    getUserPlan() {
      let _self = this;

      _self.$axios.get("societyadmin/user-plan").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.isExpired = data.isExpired;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    logout() {
      let _self = this;

      _self.loading = true;

      _self.$axios.post("/societyadmin/logout").then((response) => {
        let data = response.data;
        _self.loading = false;

        if (data.status) {
          localStorage.removeItem("user");
          localStorage.removeItem("flag");
          localStorage.removeItem("selectedTab");
          this.$router.push({ path: "/societyadmin/login" });
        } else {
          if (data.errors) {
            for (let i = 0; i < data.errors.length; i++) {
              _self.errors[data.errors[i].field] = data.errors[i].message;
            }
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red variant-2",
              timeout: "2000",
              message: data.message,
            });
          }
        }
      });
    },
    submitForm() {
      let _self = this;
      _self.loading = true;
      const formData = new FormData();
      for (const key in this.feedback) {
        if (Object.prototype.hasOwnProperty.call(this.feedback, key)) {
          formData.append(key, this.feedback[key]);
        }
      }
      _self.$axios.post("societyadmin/feedback/", formData).then((response) => {
        let data = response.data;

        if (data.status) {
          this.dialogFeedback = false;
          this.setAlert({
            showAlert: true,
            variant: "green accent-4",
            timeout: "2000",
            message: data.message,
          });
        } else {
          if (!data.errors) {
            this.setAlert({
              showAlert: true,
              message: data.message,
              variant: "red accent-3",
              timeout: 2000,
            });
          } else {
            _self.serverSideErrors = {};
            for (let i = 0; i < data.errors.length; i++) {
              this.serverSideErrors[data.errors[i].field] =
                data.errors[i].message;
            }
            console.log(this.serverSideErrors);
          }
        }
      });
    },
    getSocietyDetail() {
    let _self = this;
    _self.$axios.get("/societyadmin/societyProfile").then((response) => {
      let data = response.data;

      if (data.status) {
        _self.user = data.society;

        console.log(_self.user);
      } else {
        if (data.errors) {
          _self.serverSideErrors = {};

          for (let i = 0; i < data.errors.length; i++) {
            _self.serverSideErrors[data.errors[i].field] =
              data.errors[i].message;
          }
        } else {
          this.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      }
    });
  },
  },


  // mounted() {
  //   // this.user = JSON.parse(localStorage.getItem("user"));

  // },
  computed: {
    filteredNavigationItems() {
      if (this.isExpired === false) {
        return this.navigationItems.filter(
          (item) => item.title === "My Plan" || item.title === "Dashboard"
        );
      } else {
        return this.navigationItems;
      }
    },
  },
};
</script>

<style scoped>
.min-width-200 {
  width: 200px !important;
}
</style>
